import styled from 'styled-components'

export const RestrictionsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`

export const StatusBadge = styled.span<{
  $status: 'success' | 'warning' | 'neutral'
}>`
  display: inline-flex;
`

export const AffectedTypes = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.micro};
`

export const TypeChip = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.primary};

  span {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
  }
`
